import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { translations } from "@/lib/content";
import { useLanguage } from "@/hooks/useLanguage";
import { useHashScroll } from "@/hooks/useHashScroll";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import MobileCallBar from "@/components/sections/MobileCallBar";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import { Toaster } from "@/components/ui/sonner";
import SplashIntro from "@/components/SplashIntro";

const MOBILE_CALL_BAR_HEIGHT = 72;
const TOAST_MOBILE_OFFSET = { bottom: MOBILE_CALL_BAR_HEIGHT };

function HashScroll() {
  useHashScroll();
  return null;
}

function App() {
  const [lang, setLang] = useLanguage();
  const t = translations[lang];

  return (
    <BrowserRouter>
      <HashScroll />
      <SplashIntro />
      <div className="App min-h-screen bg-brand-light font-body" data-testid="app-root">
        <Header t={t} lang={lang} setLang={setLang} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage t={t} lang={lang} />} />
            <Route path="/privacy" element={<LegalPage t={t} doc={t.legal.privacy} testId="privacy-page" />} />
            <Route path="/terms" element={<LegalPage t={t} doc={t.legal.terms} testId="terms-page" />} />
          </Routes>
        </main>
        <Footer t={t} />
        <MobileCallBar t={t} />
        <Toaster position="bottom-right" richColors closeButton mobileOffset={TOAST_MOBILE_OFFSET} />
      </div>
    </BrowserRouter>
  );
}

export default App;
